var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { FreeHtml } from "sb-resp-ui";
import Debounce from "debounce-decorator";
var RibbonMessage = /** @class */ (function (_super) {
    __extends(RibbonMessage, _super);
    function RibbonMessage(props) {
        var _this = _super.call(this, props) || this;
        _this.ref = React.createRef();
        _this.boundOwnResizeHandler = _this.ownResizeHandler.bind(_this);
        return _this;
    }
    RibbonMessage.prototype.componentDidMount = function () {
        window.addEventListener("resize", this.boundOwnResizeHandler);
        this.ownResizeHandler();
    };
    /* istanbul ignore next */
    RibbonMessage.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.message !== prevProps.message) {
            this.ownResizeHandler();
        }
    };
    /* istanbul ignore next */
    RibbonMessage.prototype.componentWillUnmount = function () {
        window.removeEventListener("resize", this.boundOwnResizeHandler);
    };
    RibbonMessage.prototype.ownResizeHandler = function () {
        this.ref.current && this.ref.current.firstElementChild && this.props.resizeHandler(this.ref.current.clientWidth, this.ref.current.firstElementChild.scrollWidth);
    };
    /* istanbul ignore next */
    RibbonMessage.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { ref: this.ref, className: this.props.className, onClick: function (e) { return _this.props.handler(e); } },
            React.createElement(FreeHtml, { html: this.props.message })));
    };
    __decorate([
        Debounce(50),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RibbonMessage.prototype, "ownResizeHandler", null);
    return RibbonMessage;
}(React.Component));
export { RibbonMessage };
//# sourceMappingURL=RibbonMessage.js.map